import { extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Icon as Icon$1, Box } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../../icons/library.js';

// see FontAwesomeIconProps in react-fontawesome for all available FA props

var Icon = function Icon(props) {
  var alignSelf = props.alignSelf,
    className = props.className,
    color = props.color,
    colorScheme = props.colorScheme,
    flip = props.flip,
    icon = props.icon,
    iconName = props.iconName,
    prefix = props.prefix,
    _props$size = props.size,
    size = _props$size === void 0 ? '1x' : _props$size,
    spin = props.spin,
    transform = props.transform,
    boxSize = props.boxSize,
    fontSize = props.fontSize,
    height = props.height,
    _props$lineHeight = props.lineHeight,
    lineHeight = _props$lineHeight === void 0 ? 'inherit' : _props$lineHeight,
    margin = props.margin,
    minHeight = props.minHeight,
    minWidth = props.minWidth,
    padding = props.padding,
    width = props.width;

  /**
   * DOM
   */
  var hasIcon = iconName || icon;
  if (!hasIcon) {
    return null;
  }
  var getTransform = function getTransform(transform) {
    var _transform$rotate, _transform$x, _transform$y;
    if (!transform) {
      return '';
    }
    if (typeof transform === 'string') {
      return transform;
    }
    return _objectSpread2(_objectSpread2({}, transform), {}, {
      rotate: (_transform$rotate = transform.rotate) !== null && _transform$rotate !== void 0 ? _transform$rotate : 0,
      x: (_transform$x = transform.x) !== null && _transform$x !== void 0 ? _transform$x : 0,
      y: (_transform$y = transform.y) !== null && _transform$y !== void 0 ? _transform$y : 0
    });
  };
  var iconProps = {
    className: className,
    flip: flip,
    size: size,
    spin: spin,
    transform: getTransform(transform)
  };
  var styleProps = {
    boxSize: boxSize,
    width: width,
    minWidth: minWidth,
    height: height,
    minHeight: minHeight,
    margin: margin,
    padding: padding,
    fontSize: fontSize,
    lineHeight: lineHeight,
    alignSelf: alignSelf
  };
  if (icon) {
    return /*#__PURE__*/React.createElement(Icon$1, _extends({}, styleProps, {
      color: colorScheme ? "icon-".concat(colorScheme) : color,
      as: icon
    }));
  }
  var iconProp = prefix ? [prefix, iconName] : iconName;
  var ThirdPartyIcon = function ThirdPartyIcon() {
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({
      icon: iconProp
    }, iconProps));
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: 'span',
    display: "inline-block",
    color: colorScheme ? "icon-".concat(colorScheme) : color
  }, styleProps), /*#__PURE__*/React.createElement(Icon$1, {
    as: ThirdPartyIcon
  }));
};
Icon.displayName = "Icon";
export { Icon };